import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-button',
  animations: [
    trigger('select', [
      // ...
      state('open', style({
        height: '200px',
        opacity: 1,
        backgroundColor: 'yellow'
      })),
      state('closed', style({
        height: '100px',
        opacity: 0.5,
        backgroundColor: 'green'
      })),
      transition('open => closed', [
        animate('1s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements AfterViewInit {

  @ViewChild('buttn') button: ElementRef<HTMLElement>;

  @Input() @HostBinding('class.disabled') disabled = false;
  @Input() styles = {};
  @Input() type = 'button';
  @Input() id;
  @HostBinding('class.active') @Input() active = false;
  @HostBinding('class.simple') @Input() simple = false;
  @HostBinding('class.simpleGray') @Input() simpleGray = false;
  @HostBinding('class.simpleGreen') @Input() simpleGreen = false;
  @HostBinding('class.stroked') @Input() stroked = false;

  @Output() clicked = new EventEmitter<any>();


  onClick(e) {
    this.clicked.emit();
    if (this.type !== 'submit') {
      e.stopPropagation();
      return false;
    }
  }

  ngAfterViewInit(): void {
    if (this.id) {
      this.button.nativeElement.setAttribute('id', this.id + '_sub');
    }
  }

}
